import React, { useState } from 'react'
import ViemoVideo from '../ViemoVideo/ViemoVideo';
import Portal from '../Portal/Portal';
import VideoIcon from '../VideoIcon/VideoIcon';

const ViemoIcon = ({icon, videoId}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isHover, setIsHover] = useState(false);
    const handleMouseEnter = () => setIsHover(true);
    const handleMouseLeave = () => setIsHover(false);

    const handleOnClick = () => {
        setIsOpen(true);
        handleMouseLeave();
    }
    const setOnClick = (state) => setIsOpen(state);

    const iconStyle = {
        cursor: 'pointer',
        background: isHover ? '#CCC' : '',
        padding: '4px 8px',
    }

    return (
        <div style={iconStyle} onClick={handleOnClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} >
            {/* <img style={{width: '4rem'}} src={icon} alt='viemo-video-icon' /> */}
            <div style={{ height: '50px', width: '50px' }}>
                <VideoIcon />
            </div>
            
            {isOpen && (
                <Portal>
                    <ViemoVideo setOnClick={setOnClick} videoId={videoId} />
                </Portal>
            )}
            
        </div>
    )
}

export default ViemoIcon;